<template>
  <div class="flex flex-1 flex-col overflow-x-hidden">
    <FlotoForm>
      <MRow :gutter="0" class="flex-1">
        <template v-if="resource.movementType !== 'asset_transfer'">
          <MDivider class="mt-0 mb-2" />
          <MCol :size="12">
            <MRow :gutter="0">
              <MCol class="mx-2" :size="4">
                <FlotoFormItemReadOnly
                  :value="resource.phone"
                  :label="`${$tc('name')}`"
                >
                  <VendorPicker text-only :value="resource.vendorId" disabled />
                </FlotoFormItemReadOnly>
              </MCol>
            </MRow>
          </MCol>
          <MCol :size="12">
            <MRow :gutter="0">
              <MCol class="mx-2">
                <FlotoFormItemReadOnly
                  :value="resource.phone"
                  :label="`${$tc('asset_enum.mobile')}`"
                >
                  {{ resource.contactNo || '---' }}
                </FlotoFormItemReadOnly>
              </MCol>
            </MRow>
          </MCol>
          <MCol :size="12">
            <MRow :gutter="0">
              <MCol class="mx-2">
                <FlotoFormItemReadOnly
                  :value="resource.email"
                  :label="`${$tc('email')}`"
                >
                  {{ resource.email || '---' }}
                </FlotoFormItemReadOnly>
              </MCol>
            </MRow>
          </MCol>
          <MDivider />
        </template>
        <MCol :size="6" class="mt-2">
          <MRow v-if="resource.movementType !== 'asset_transfer'" :gutter="0">
            <MCol class="mx-2">
              <h6
                class="text-neutral-light flex justify-between cursor-pointer items-center"
              >
                {{ $tc('address') }}
              </h6>
            </MCol>
            <MDivider class="mt-0 mb-2" />
          </MRow>
          <MRow :gutter="0">
            <MCol class="mx-2">
              <AddressForm key="shipping" :value="resource.address" disabled />
            </MCol>
          </MRow>
        </MCol>
      </MRow>
      <template v-slot:submit>
        <span />
      </template>
    </FlotoForm>
  </div>
</template>
<script>
import VendorPicker from '@components/data-picker/vendor-picker'
import AddressForm from '@components/address-form.vue'
export default {
  name: 'VendorTab',
  components: { AddressForm, VendorPicker },
  props: {
    resource: { type: Object, required: true },
  },
  data() {
    return {
      vendorData: {},
    }
  },
}
</script>
